module.exports = __webpack_public_path__ + "img/quest-logo.693a4db1.png";